import React from 'react';
import Hero from './components/IQAC/feedback/Hero';
import Main from './components/IQAC/feedback/Main';

const IqacFeedback = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacFeedback;